
import { TestLetterGeneration } from "@/components/TestLetterGeneration"

export default function TestAI() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto py-8">
        <TestLetterGeneration />
      </div>
    </div>
  )
}
